"use strict";

var _interopRequireDefault = require("/Users/john/Desktop/Projects/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/john/Desktop/Projects/nq-component/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _slicedToArray2 = _interopRequireDefault(require("/Users/john/Desktop/Projects/nq-component/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _objectWithoutProperties2 = _interopRequireDefault(require("/Users/john/Desktop/Projects/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _InputFactory = _interopRequireDefault(require("../InputFactory"));
var _FormTab = _interopRequireDefault(require("./FormTab"));
var _checkCondition = _interopRequireDefault(require("../checkCondition"));
var _toDisplayCase = _interopRequireDefault(require("../toDisplayCase"));
var _excluded = ["className", "schema", "object", "onChange", "excludeFields", "hasLabel", "roles"],
  _excluded2 = ["type", "pattern", "write", "tab", "col", "_io", "_required", "required"];
var _jsxFileName = "/Users/john/Desktop/Projects/nq-component/src/FormFactory/index.js";
/**
 * Group the fields in the schema based on sections and return the grouped fields object.
 * @param {Object} schema - The schema object containing the fields and sections.
 * @returns {Object} - The grouped fields object.
 */
function group(schema) {
  var fields = schema.fields,
    sections = schema.sections;
  var groups = {
    "General": {}
  };
  for (var key in fields) {
    var options = fields[key];
    if (sections && sections[options.section]) {
      groups[options.section] = groups[options.section] || {};
      groups[options.section][key] = options;
    } else {
      groups["General"][key] = options;
    }
  }
  return groups;
}
var defaultProps = {
  excludeFields: [],
  hasLabel: true
};

/**
 * FormFactory component renders a form based on the provided schema and object data.
 * @param {Object} props - The component props.
 * @param {Object} props.schema - The schema object defining the form structure.
 * @param {Object} props.object - The object data to populate the form fields.
 * @param {Function} props.onChange - The callback function called when a form field value changes.
 * @returns {JSX.Element} - The rendered form component.
 */
function FormFactory(_ref) {
  var _this = this;
  var className = _ref.className,
    schema = _ref.schema,
    object = _ref.object,
    onChange = _ref.onChange,
    excludeFields = _ref.excludeFields,
    hasLabel = _ref.hasLabel,
    roles = _ref.roles,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var tabs = schema.tabs;
  var initialTab = tabs && Object.keys(tabs).length > 0 ? Object.keys(tabs)[0] : null; // Set the initial tab value
  var _React$useState = _react["default"].useState(initialTab),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    _tab = _React$useState2[0],
    setTab = _React$useState2[1];
  var sections = schema.sections || {};
  var groups = group(schema);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_FormTab["default"], {
    roles: roles,
    onSet: setTab,
    tabs: tabs,
    object: object,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 49,
      columnNumber: 9
    }
  }), Object.keys(groups).map(function (key) {
    var fields = groups[key];
    var _ref2 = sections[key] || {},
      label = _ref2.label;
    var components = Object.keys(fields).map(function (field) {
      var _ref3, _props$required;
      if (excludeFields.includes(field)) return null;
      var conditions = fields[field]["if"] || fields[field].or || fields[field].and;
      if (conditions && !(0, _checkCondition["default"])(fields[field], object)) {
        return null;
      }
      var _fields$field = fields[field],
        type = _fields$field.type,
        pattern = _fields$field.pattern,
        write = _fields$field.write,
        tab = _fields$field.tab,
        col = _fields$field.col,
        _io = _fields$field._io,
        _required = _fields$field._required,
        required = _fields$field.required,
        options = (0, _objectWithoutProperties2["default"])(_fields$field, _excluded2);
      if (_tab && tab && _tab !== tab) return null;
      if (write === false || _io === false) return null;
      if (field === 'password') {
        type = "Password";
      }
      var __required = (_ref3 = (_props$required = props.required) !== null && _props$required !== void 0 ? _props$required : _required) !== null && _ref3 !== void 0 ? _ref3 : required;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: col || className,
        key: field,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 71,
          columnNumber: 25
        }
      }, type !== 'Boolean' && hasLabel && /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-label fs-sm",
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 75,
          columnNumber: 25
        }
      }, options.label || (0, _toDisplayCase["default"])(field), " ", __required && /*#__PURE__*/_react["default"].createElement("span", {
        className: "text-danger",
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 77,
          columnNumber: 84
        }
      }, "*")), props.componentFactory ? /*#__PURE__*/_react["default"].createElement(props.componentFactory, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({
        object: object,
        field: field,
        onChange: onChange,
        type: type,
        required: __required
      }, options), props)) : /*#__PURE__*/_react["default"].createElement(_InputFactory["default"], Object.assign({
        object: object,
        field: field,
        onChange: onChange,
        type: type,
        required: __required
      }, options, props, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 88,
          columnNumber: 26
        }
      })));
    }).filter(function (c) {
      return c;
    });
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, components.length > 0 && Object.keys(sections).length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
      className: "col-12",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 101,
        columnNumber: 82
      }
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: "small fw-bold mb-0 ms-1",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 102,
        columnNumber: 21
      }
    }, label || key), /*#__PURE__*/_react["default"].createElement("hr", {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 103,
        columnNumber: 21
      }
    })), components);
  }));
}
FormFactory.defaultProps = defaultProps;
var _default = exports["default"] = FormFactory;